/**
 * Exporta a CSV el listado de materias revalidadas/por revalidar.
 *
 * Genera un Blob con BOM UTF-8 (para compatibilidad con Excel español).
 * Formato CSV puro (separador ",", comillas escapadas).
 */

function csvCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  // Si contiene coma, salto de línea o comillas, encerrar entre comillas y escapar.
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function csvRow(arr) {
  return arr.map(csvCell).join(',');
}

function pad2(n) { return n < 10 ? `0${n}` : `${n}`; }

function timestampPart() {
  const d = new Date();
  return (
    `${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}` +
    `_${pad2(d.getHours())}${pad2(d.getMinutes())}`
  );
}

/**
 * @param {Object} args
 * @param {Array}  args.filas         - Materias mostradas en pantalla.
 * @param {Object} args.contexto      - { matricula, nombre, programa, seccion, campus, ciclo }
 */
export function exportMateriasRevalidarCSV({ filas = [], contexto = {} } = {}) {
  const lines = [];

  lines.push(csvRow(['Reporte: Materias Equivalentes a Revalidar']));
  lines.push(csvRow([`Generado: ${new Date().toLocaleString()}`]));
  lines.push(csvRow([`Matricula: ${contexto.matricula || ''}`]));
  lines.push(csvRow([`Estudiante: ${contexto.nombre || ''}`]));
  lines.push(csvRow([`Programa: ${contexto.programa || ''}`]));
  lines.push(csvRow([`Seccion: ${contexto.seccion || ''}`]));
  lines.push(csvRow([`Campus: ${contexto.campus || ''}`]));
  lines.push(csvRow([`Ciclo Escolar: ${contexto.ciclo || ''}`]));
  lines.push('');

  lines.push(csvRow([
    'Clave',
    'Materia',
    'Creditos',
    'Periodo Sugerido',
    'Año Ciclo (Procedencia)',
    'Calificacion Revalidada',
    'Escuela de Procedencia',
    'Observaciones',
    'Estado Actual',
  ]));

  filas.forEach((row) => {
    lines.push(csvRow([
      row.clave_materia || '',
      row.nombre_materia || '',
      row.creditos ?? '',
      row.periodo_sugerido ?? '',
      row.rev_anio_ciclo_escolar || '',
      row.rev_calificacion_final || '',
      row.rev_escuela_procedencia || '',
      row.rev_observaciones || '',
      row.tipo_curso_actual ? `Cardex: ${row.tipo_curso_actual}` : 'Pendiente',
    ]));
  });

  const csv = lines.join('\r\n');
  // BOM UTF-8 para que Excel en español interprete acentos correctamente.
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });

  const fileName = `${timestampPart()}_materias_revalidar_${contexto.matricula || 'estudiante'}.csv`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
